module.exports = __webpack_public_path__ + "img/logo-gray-stripe.a8d773d0.png";